import { Button, Table, TableColumns, TableColumnWidth, TableData, TablePreferences } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleMessageModal from "../../components/Modals/SimpleMessageModal";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import { AgendaStatus } from "../../models/enum/AgendaStatus";
import appointmentService from "../../services/agendaApi/appointment.service";
import '../../assets/css/views/agenda.css';
import { ISimpleMessageDto } from "../../models/dto/application/ISimpleMessageDto";
import BackButton from "../../features/path/backButton";
import { useNavigate } from "react-router-dom";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";

export default function Agendas() {
  const [loadingData, setLoadingData] = useState(true);
  const [t] = useTranslation("global");
  const [agendas, setAgendas] = useState<TableData[]>([]);
  const navigate = useNavigate();
  const [simpleMessage, setSimpleMessage] = useState<ISimpleMessageDto>({ showModal: false, modalMessage: '', modalTitle: '' });

  useEffect(() => {
    getAgendas();
  }, [])

  const getAgendas = () => {
    setLoadingData(true);
    appointmentService.getAppointmentByUser()
      .then((r: any) => {
        if (validateAgendaStatus(r[0])) {
          fillData(r);
        }
      }).finally(() => setLoadingData(false));
  }

  const validateAgendaStatus = (data: IAppointmentDto): Boolean => {
    let showData: Boolean = false;
    if (data.userStatus === AgendaStatus.noAgendas) {
      setSimpleMessage({ showModal: true, modalMessage: t('header.noAgendas'), modalTitle: t('header.information') })
    } else if (data.userStatus === AgendaStatus.hasAbsence) {
      setSimpleMessage({ showModal: true, modalMessage: t('header.hasAbsences'), modalTitle: t('header.information') })
    } else {
      showData = true;
    }
    return showData;
  }

  const handleActivitiesButton = (appointmentId: number) => {
    navigate(`/activitiesByAppointment/${appointmentId}`);
  }

  const fillData = (data: IAppointmentDto[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const agenda: IAppointmentDto = data[i];
      let tableData: TableData = {};
      tableData = {
        'status': <div id="outer-circle"><div id="inner-circle"></div></div>,
        'posCode': agenda.posCode,
        'pos': agenda.pos,
        'company': agenda.companyName,
        'scheduledTime': agenda.assignHourIn,
        'registeredTime': agenda.checkInDatetime == null ? t('header.notRegister') : agenda.checkInDatetime,
        'activities': <div>{(agenda.checkInDatetime !== null || agenda.userStatus === AgendaStatus.homeOffice)  && <Button small onClick={() => handleActivitiesButton(agenda.appointmentId)} >{t("header.activities")}</Button>}</div>
      }
      pagedData.push(tableData);
    }
    setAgendas(pagedData);
  }

  const columns: TableColumns[] = [
    { id: 'status', label: '' },
    { id: 'posCode', label: t("header.posOfCode") },
    { id: 'pos', label: t("header.pos") },
    { id: 'company', label: t("header.company") },
    { id: 'scheduledTime', label: t("header.scheduledTime") },
    { id: 'registeredTime', label: t("header.registeredTime") },
    { id: 'activities', label: '' }
  ];

  const columnsWidth: TableColumnWidth[] = [
    { columnId: 'status', width: '10%' },
    { columnId: 'posCode', width: '20%' },
    { columnId: 'pos', width: '20%' },
    { columnId: 'company', width: '20%' },
    { columnId: 'scheduledTime', width: '10%' },
    { columnId: 'registeredTime', width: '10%' },
    { columnId: 'activities', width: '10%' }
  ]

  const tablePreferences: TablePreferences = {
    width: columnsWidth
  }

  return (
    <div>
      <div style={{ padding: '20px' }}>
        <BackButton route={BreadCrumbsEnum.Agenda} />
        <h4>{t("header.agenda")}</h4>
        <div style={{ padding: '20px' }}>
          <Table
            preferences={tablePreferences}
            loading={loadingData}
            columns={columns}
            data={agendas}
            css={{
              height: '60vh'
            }}
            columnResize={true}
          />
        </div>
      </div>
      <SimpleMessageModal simpleMessage={simpleMessage}></SimpleMessageModal>
      <div>
      </div>
    </div>
  );
}